/**
 * DSC Grind Selector v6
 * Uses same morphSection approach as the theme's cart-items-component.
 * Passes sections[] in the cart API calls so the response includes re-rendered HTML.
 * Updates the DOM in-place — drawer stays open, no page reload.
 */

(function () {
  'use strict';

  // Collect all cart-items-component section IDs (full page + drawer)
  function getSectionIds() {
    const ids = new Set();
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      ids.add(el.dataset.sectionId);
    });
    // Fallback: find shopify-section wrappers containing cart items
    if (!ids.size) {
      const wrapper = document.querySelector('[id*="__cart-section"]');
      if (wrapper) ids.add(wrapper.id.replace('shopify-section-', ''));
    }
    return Array.from(ids);
  }

  // Morph a section in place using the rendered HTML from the API response
  function morphSectionHTML(sectionId, newHTML) {
    const wrapper = document.getElementById('shopify-section-' + sectionId);
    if (!wrapper || !newHTML) return false;

    // Use theme's morphSection if available
    if (typeof window.morphSection === 'function') {
      window.morphSection(sectionId, newHTML);
      return true;
    }

    // Fallback: find and update just the cart-items-component inside the section
    // to avoid destroying the drawer shell
    const tmp = document.createElement('div');
    tmp.innerHTML = newHTML;

    // For drawer: only replace the inner content, not the drawer wrapper
    const drawerInner = wrapper.querySelector('.cart-drawer__inner, cart-items-component');
    const newDrawerInner = tmp.querySelector('.cart-drawer__inner, cart-items-component');

    if (drawerInner && newDrawerInner) {
      drawerInner.innerHTML = newDrawerInner.innerHTML;
    } else {
      // Full cart page: safe to replace whole section
      const newSection = tmp.firstElementChild;
      if (newSection) wrapper.replaceWith(newSection);
    }
    return true;
  }

  function fixSelectValues() {
    document.querySelectorAll('.dsc-grind-change__select').forEach(function (sel) {
      const correct = sel.dataset.selectedGrind;
      if (correct && sel.value !== correct) sel.value = correct;
    });
  }

  function initGrindSelectors() {
    document.querySelectorAll('.dsc-grind-change__select').forEach(function (select) {
      if (select.dataset.dscBound) return;
      select.dataset.dscBound = '1';

      select.addEventListener('change', function () {
        const container  = select.closest('.dsc-grind-change');
        const itemKey    = container.dataset.itemKey;
        const variantMap = container.dataset.variantMap || '';
        const newGrind   = select.value;
        const prevGrind  = select.dataset.selectedGrind;

        // Parse variant map
        const map = {};
        variantMap.split(',').forEach(function (entry) {
          const idx = entry.indexOf(':');
          if (idx > -1) map[entry.substring(0, idx).trim()] = entry.substring(idx + 1).trim();
        });

        const newVariantId = map[newGrind];
        if (!newVariantId) {
          console.error('DSC Grind: no variant for', newGrind, map);
          select.value = prevGrind;
          return;
        }

        select.disabled = true;

        const sectionIds = getSectionIds();
        const row = container.closest('[data-key]');
        const qtyInput = row?.querySelector('[name="updates[]"]') || row?.querySelector('quantity-input input');
        const qty = parseInt(qtyInput?.value || '1') || 1;

        // Step 1: Remove old variant (quantity 0)
        // Step 2: Add new variant with sections in body so response includes rendered HTML
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: itemKey, quantity: 0 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: parseInt(newVariantId),
              quantity: qty,
              sections: sectionIds
            })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.id && !data.items) throw new Error(JSON.stringify(data));

          // Update sections in place
          const sections = data.sections || {};
          let updated = false;
          sectionIds.forEach(function (sid) {
            if (sections[sid]) {
              morphSectionHTML(sid, sections[sid]);
              updated = true;
            }
          });

          // Re-init after DOM update
          setTimeout(init, 150);

          // If no section HTML returned, fall back to reload
          if (!updated) window.location.reload();
        })
        .catch(function (err) {
          console.error('DSC Grind: swap failed', err);
          select.disabled = false;
          select.value = prevGrind;
          alert('Could not update grind. Please remove and re-add the item.');
        });
      });
    });
  }

  function checkMixedGrinds() {
    const selects = document.querySelectorAll('.dsc-grind-change__select');
    document.querySelector('.dsc-mixed-grind-banner')?.remove();
    if (selects.length < 2) return;

    const grinds = Array.from(selects).map(function (s) {
      return s.dataset.selectedGrind || s.value;
    });
    const unique = [...new Set(grinds)];
    if (unique.length < 2) return;

    const banner = document.createElement('div');
    banner.className = 'dsc-mixed-grind-banner';
    banner.innerHTML = '⚠️ <strong>Mixed grinds in your basket:</strong> ' +
      unique.join(' &amp; ') +
      ' — please check this is intentional before ordering.';

    const targets = ['.cart-summary__inner', '.cart-summary', '[data-cart-summary]', '.cart-items__table'];
    for (const sel of targets) {
      const el = document.querySelector(sel);
      if (el) { el.insertAdjacentElement('afterend', banner); break; }
    }
  }

  function init() {
    fixSelectValues();
    initGrindSelectors();
    checkMixedGrinds();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); setTimeout(init, 600); });
  } else {
    init();
    setTimeout(init, 600);
  }

  // Watch for drawer/section re-renders
  const observer = new MutationObserver(function (mutations) {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && node.querySelector?.('.dsc-grind-change')) {
          setTimeout(init, 100);
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
